var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, cloneElement } from 'react';
import _merge from 'lodash.merge';
import ECharts from '../ECharts';
import Tooltip from '../components/Tooltip';
import Legend from '../components/Legend';
import XAxis from '../components/XAxis';
import YAxis from '../components/YAxis';
import Scatter from '../series/Scatter';
import { EChartsContext } from '../constants';
import { is } from '../utils';
const xAxisProps = {
    axisLine: {
        symbol: ['none', 'arrow'],
        symbolSize: [9, 9]
    },
    nameLocation: 'center',
    nameGap: 25,
    nameTextStyle: {
        fontSize: 14,
        color: '#272c36'
    }
};
const yAxisProps = {
    axisLine: {
        show: true,
        symbol: ['none', 'arrow'],
        symbolSize: [9, 9]
    },
    splitLine: false,
    nameLocation: 'middle',
    nameGap: 35,
    nameTextStyle: {
        fontSize: 14,
        lineHeight: 20,
        color: '#272c36'
    }
};
function ScatterChart(_a, ref) {
    var { name, data = [], tooltip = true, legend = true, children } = _a, props = __rest(_a, ["name", "data", "tooltip", "legend", "children"]);
    function renderDefaultScatter() {
        return React.createElement(Scatter, { name: name, data: data });
    }
    const components = Children.toArray(children);
    return (React.createElement(EChartsContext.Provider, { value: { chartType: 'scatter', dataName: name } },
        React.createElement(ECharts, Object.assign({ ref: ref }, props),
            !components.find(comp => is(comp, 'xAxis')) && React.createElement(XAxis, Object.assign({}, xAxisProps)),
            !components.find(comp => is(comp, 'yAxis')) && React.createElement(YAxis, Object.assign({}, yAxisProps)),
            !components.find(comp => is(comp, 'scatter')) && renderDefaultScatter(),
            tooltip && React.createElement(Tooltip, null),
            legend && React.createElement(Legend, { icon: "circle", itemHeight: 10, itemWidth: 10, itemGap: 30 }),
            components.map((child) => {
                if (is(child, 'xAxis')) {
                    return cloneElement(child, _merge(xAxisProps, child.props));
                }
                if (is(child, 'yAxis')) {
                    return cloneElement(child, _merge(yAxisProps, child.props));
                }
                return child;
            }))));
}
export default React.forwardRef(ScatterChart);
//# sourceMappingURL=ScatterChart.js.map